import { ExternalLinkIcon, MailIcon } from 'lucide-react'
import { useState } from 'react'

import { useOnboardingStep } from 'components/hooks/employer_onboarding/useOnboardingStep'
import { BorderedRadioButton, Button, ButtonLink, RadioGroup, TextLink, usePageTitle } from 'slab'

import { CenteredLayout } from '../CenteredLayout'

type EmployeeOption = 'setup' | 'signin'

export function EmployeeLandingPage () {
  usePageTitle('Welcome to Thatch')
  const { navigateToPreviousStep } = useOnboardingStep()
  const [selectedOption, setSelectedOption] = useState<EmployeeOption | null>(null)

  return (
    <CenteredLayout verticallyCentered>
      <CenteredLayout.Header
        heading="We're happy to have you here!"
        subheading='What best describes you?'
      />
      <CenteredLayout.Container hideCard padded={false}>
        <RadioGroup name='employee_option' layout='horizontal' gap={4}>
          <div className='grid md:grid-cols-2 gap-4 w-full'>
            <BorderedRadioButton
              value='setup'
              label='I need to set up my new Thatch benefits'
              onChange={() => setSelectedOption('setup')}
              checked={selectedOption === 'setup'}
              size='large'
            />
            <BorderedRadioButton
              value='signin'
              label='I need to sign into my Thatch account'
              onChange={() => setSelectedOption('signin')}
              checked={selectedOption === 'signin'}
              size='large'
            />
          </div>
        </RadioGroup>
      </CenteredLayout.Container>

      <div className='mt-8 min-h-48'>
        {selectedOption === 'setup' && (
          <div className='text-center space-y-4'>
            <div className='flex items-baseline gap-3'>
              <p className='heading-sm flex items-start gap-2'>
                <MailIcon className='w-5 h-5 text-gray-500 mt-0.5 shrink-0' />
                Check your inbox for an email with the subject: "Your employer is inviting you to select your health benefits through Thatch"
              </p>
            </div>
            <p className='body text-gray-600'>
              You'll need to click the link in your email that your employer sent you in order to create your Thatch account.
            </p>
            <p className='body text-gray-600'>
              Don't have the link? Reach out to your employer and ask them to resend it!
            </p>
          </div>
        )}

        {selectedOption === 'signin' && (
          <div className='text-center space-y-4'>
            <p className='heading-sm'>
              Use the employee sign in link
            </p>
            <p className='body text-gray-600'>
              Go to <TextLink color='purple' href='https://app.thatch.com/login'>app.thatch.com/login</TextLink> or click "Sign in to Thatch" below to access the sign in page.
            </p>
          </div>
        )}
        <div className='mt-8'>
          <CenteredLayout.Buttons>
            <Button
              variant='secondary'
              onClick={navigateToPreviousStep}
            >
              Back
            </Button>
            {selectedOption === 'signin' && (
              <ButtonLink
                href='https://app.thatch.com/login'
                variant='primary'
                rightIcon={ExternalLinkIcon}
              >
                Sign in to Thatch
              </ButtonLink>
            )}
          </CenteredLayout.Buttons>
        </div>
      </div>
    </CenteredLayout>
  )
}
